import React from 'react';

const Service = ({ service }) => {
    const { title, img, description } = service;
    return (
        <div className="card w-96 bg-base-100 shadow-xl">
            <figure><img src={img} alt="Shoes" /></figure>
            <div className="card-body">
                <h2 className="card-title">{title}</h2>
                <p>{description}</p>
                <div className="card-actions justify-end">
                    <button className="btn btn-primary">See Details...</button>
                </div>
            </div>
        </div>
    );
};

export default Service;